import React from 'react';
import PropTypes from 'prop-types';
import {ReviewStoreListTable} from '@/components/molecules';
import {Modal} from '@/components/atoms';
import {MODAL_TYPE} from '@/utils/constants/globalStyle';

const ReviewStoreListModal = ({
  setOpenStoreListModal,
  isOpenStoreListModal
}) => {
  return (
    <Modal
      type={MODAL_TYPE.LARGE}
      isDark={true}
      onCloseModal={() => setOpenStoreListModal(false)}
      onClickSecondaryButton={() => setOpenStoreListModal(false)}
      onClickPrimaryButton={() => setOpenStoreListModal(false)}
      showModal={isOpenStoreListModal}
      title={'Store List'}
      primaryButtonText={'Done'}
      content={<ReviewStoreListTable />}
    />
  );
};

ReviewStoreListModal.propTypes = {
  setOpenStoreListModal: PropTypes.func.isRequired,
  isOpenStoreListModal: PropTypes.bool.isRequired
};

export default React.memo(ReviewStoreListModal);
